import React from 'react';
import { Box, Typography } from '@mui/material';

export const CashFlowPage: React.FC = () => {
    return (
        <Box>
            <Typography variant="h4" component="h1" gutterBottom>
                Flujo de Caja
            </Typography>
            <Typography variant="body1">
                Gestión del flujo de caja - En desarrollo
            </Typography>
        </Box>
    );
}; 